"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doesPartnerSupportSignup = exports.doesPartnerHandleExist = exports.fetchPartnersByLocation = exports.fetchPartnerSuggestions = exports.fetchPartnerByHandle = void 0;
var errors_1 = require("../errors");
var globals_1 = require("../globals");
var utils_1 = require("../utils");
var defaultPartnerLevel = globals_1.BEMER_PARTNER_LEVELS.BPPLUS;
var INCLUDE_MANUALLY_CREATED_PARTNERS_IN_QUERY = true;
/**
 * Fetches  a list of partner data from the backend for the given searchString.
 *
 * @param searchString
 * @param locale
 * @param partnerLevel
 */
var fetchPartnerSuggestions = function (searchString_1, locale_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([searchString_1, locale_1], __read(args_1), false), void 0, function (searchString, locale, partnerLevel) {
        var url, query, requestInit, response, parsedResponse, error_1;
        if (partnerLevel === void 0) { partnerLevel = defaultPartnerLevel; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!searchString) {
                        throw new errors_1.NoParameterError('No name given.');
                    }
                    if (!locale) {
                        throw new errors_1.NoLocaleError();
                    }
                    url = "".concat(utils_1.API_ENDPOINTS.PARTNER_FINDER, "/selectBox");
                    query = "\n  {\n    publicPartnerByName(query: \"".concat(searchString, "\", level: \"").concat(partnerLevel, "\", externalCountries: ").concat(INCLUDE_MANUALLY_CREATED_PARTNERS_IN_QUERY, "){\n      finderData {\n        countryCode\n        latitude\n        longitude\n        partnerFinderAddress\n        shortAddress\n        partnerFinderCompany\n        partnerFinderName\n        partnerFinderPhone\n      }\n\n      partnerData {\n        customerNo\n        handle\n        levelName\n        level\n        name\n      }\n    }\n  }");
                    requestInit = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ query: query }),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, requestInit)];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    parsedResponse = _a.sent();
                    if (!response) {
                        throw new errors_1.NoResponseReceivedError();
                    }
                    if (!parsedResponse) {
                        throw new errors_1.NoPartnerFoundError();
                    }
                    if (!parsedResponse.data) {
                        throw new errors_1.NoDataFoundError();
                    }
                    if (!parsedResponse.data.publicPartnerByName) {
                        throw new Error('No publicPartnerByName in response found');
                    }
                    return [2 /*return*/, parsedResponse.data.publicPartnerByName];
                case 4:
                    error_1 = _a.sent();
                    console.error(error_1);
                    throw error_1;
                case 5: return [2 /*return*/];
            }
        });
    });
};
exports.fetchPartnerSuggestions = fetchPartnerSuggestions;
/**
 * Fetches the partner data from the backend for the given partner handle and optional locale.
 *
 * @param latitude
 * @param longitude
 * @param locale
 * @param partnerLevel
 */
var fetchPartnersByLocation = function (latitude_1, longitude_1, locale_1) {
    var args_1 = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args_1[_i - 3] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([latitude_1, longitude_1, locale_1], __read(args_1), false), void 0, function (latitude, longitude, locale, partnerLevel) {
        var url, query, requestInit, response, parsedResponse, error_2;
        if (partnerLevel === void 0) { partnerLevel = defaultPartnerLevel; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!latitude) {
                        throw new errors_1.NoLatitudeError();
                    }
                    if (!longitude) {
                        throw new errors_1.NoLongitudeError();
                    }
                    if (!locale) {
                        throw new errors_1.NoLocaleError();
                    }
                    url = "".concat(utils_1.API_ENDPOINTS.PARTNER_FINDER, "/selectBox");
                    query = "\n  {\n    publicPartnerByLocation(level: \"".concat(partnerLevel, "\", latitude: ").concat(latitude, ", longitude: ").concat(longitude, ", countryCode: \"").concat(locale.countryCode.toUpperCase(), "\", externalCountries: ").concat(INCLUDE_MANUALLY_CREATED_PARTNERS_IN_QUERY, ") {\n      finderData {\n        countryCode\n        latitude\n        longitude\n        partnerFinderAddress\n        shortAddress\n        partnerFinderCompany\n        partnerFinderName\n        partnerFinderPhone\n      }\n\n      partnerData {\n        customerNo\n        handle\n        levelName\n        level\n        name\n      }\n    }\n  }");
                    requestInit = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ query: query }),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, requestInit)];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    parsedResponse = _a.sent();
                    if (!response) {
                        throw new errors_1.NoResponseReceivedError();
                    }
                    if (!parsedResponse) {
                        throw new errors_1.NoPartnerFoundError();
                    }
                    if (!parsedResponse.data) {
                        throw new errors_1.NoDataFoundError();
                    }
                    if (!parsedResponse.data.publicPartnerByLocation) {
                        throw new Error('No publicPartnerByLocation in response found');
                    }
                    return [2 /*return*/, parsedResponse.data.publicPartnerByLocation];
                case 4:
                    error_2 = _a.sent();
                    console.error(error_2);
                    throw error_2;
                case 5: return [2 /*return*/];
            }
        });
    });
};
exports.fetchPartnersByLocation = fetchPartnersByLocation;
/**
 * Fetches the partner data from the backend for the given partner handle and optional locale.
 *
 * HINT: resolver does not use the locale param -> partnerHandles are unique across all regions
 *
 * @param handle
 * @param locale
 */
var fetchPartnerByHandle = function (handle, locale) { return __awaiter(void 0, void 0, void 0, function () {
    var url, localeParam, query, requestInit, response, parsedResponse, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!handle) {
                    throw new errors_1.NoHandleError();
                }
                url = "".concat(utils_1.API_ENDPOINTS.PARTNER_FINDER, "/selectBox");
                localeParam = locale ? ", locale: \"".concat(locale.id, "\"") : '';
                query = "\n  {\n    publicPartnerByHandle(handle: \"".concat(handle, "\", externalCountries: ").concat(INCLUDE_MANUALLY_CREATED_PARTNERS_IN_QUERY).concat(localeParam, ") {\n      finderData {\n        countryCode\n        latitude\n        longitude\n        partnerFinderAddress\n        shortAddress\n        partnerFinderCompany\n        partnerFinderName\n        partnerFinderPhone\n      }\n\n      partnerData {\n        customerNo\n        handle\n        levelName\n        level\n        name\n      }\n    }\n  }");
                requestInit = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ query: query }),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch(url, requestInit)];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 3:
                parsedResponse = _a.sent();
                if (!response) {
                    throw new errors_1.NoResponseReceivedError();
                }
                if (!parsedResponse) {
                    throw new errors_1.NoPartnerFoundError();
                }
                if (!parsedResponse.data) {
                    throw new errors_1.NoDataFoundError();
                }
                if (!parsedResponse.data.publicPartnerByHandle) {
                    throw new Error('No publicPartnerByHandle in response found');
                }
                return [2 /*return*/, parsedResponse.data.publicPartnerByHandle];
            case 4:
                error_3 = _a.sent();
                console.error(error_3);
                throw error_3;
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.fetchPartnerByHandle = fetchPartnerByHandle;
/**
 * Checks if a partner handle exists in the backend.
 *
 * @param handle
 * @param locale
 */
var doesPartnerHandleExist = function (handle, locale) { return __awaiter(void 0, void 0, void 0, function () {
    var partnerData, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!handle) {
                    return [2 /*return*/, false];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetchPartnerByHandle(handle, locale)];
            case 2:
                partnerData = _a.sent();
                return [2 /*return*/, !!partnerData.partnerData.handle];
            case 3:
                error_4 = _a.sent();
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.doesPartnerHandleExist = doesPartnerHandleExist;
/**
 * Checks if a user can be redirected to the signup page of a given partner.
 */
var doesPartnerSupportSignup = function (partner) {
    if (!(partner === null || partner === void 0 ? void 0 : partner.finderData) || !(partner === null || partner === void 0 ? void 0 : partner.partnerData)) {
        return false;
    }
    var countryCode = partner.finderData.countryCode;
    var level = partner.partnerData.level;
    if (!countryCode || level === undefined) {
        return false;
    }
    return level >= 40;
};
exports.doesPartnerSupportSignup = doesPartnerSupportSignup;
